import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import Logo from "../common/components/Logo";
import styles from "./styles";
import { strings } from "../common/i18n";

const LoadingView = () => {
    const classes = makeStyles(styles)();

    return (
        <Box>
            <LinearProgress size={64} />
            <Box className={classes.container}>
                <Box className={classes.logoContainer}>
                    <Logo />
                </Box>
                <Typography variant="h5" className={classes.primaryText}>
                    {strings("initialising")}
                </Typography>
                <Typography
                    variant="subtitle1"
                    className={classes.secondaryText}
                >
                    {strings("pleaseWait")}
                </Typography>
            </Box>
        </Box>
    );
};

export default LoadingView;
